// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.MapField_container__femHr {
  display: flex;
  flex-direction: column;
  margin-top: 18px;
}

.MapField_map-container__aZHyR {
  height: 350px;
}

.MapField_map-info__PiJ10 {
  font-size: 20px;
  font-weight: bold;
  margin: 20px 0px;
}

.MapField_error-text__aW0f1 {
  margin-bottom: 10px;
  color: #c9423c;
  font-size: 12px;
}

.MapField_error-border__r6Tyl {
  border: solid 2px #c9423c;
}

.MapField_error-border__r6Tyl:focus-within {
  outline: none !important;
  border: solid 2px #c9423c;
}`, "",{"version":3,"sources":["webpack://./src/components/Form/MapField/MapField.module.scss","webpack://./src/styles/_typography.scss"],"names":[],"mappings":"AAGA;EACI,aAAA;EACA,sBAAA;EACA,gBAAA;AAFJ;;AAKA;EACI,aAAA;AAFJ;;AAKA;EACI,eCVO;EDWP,iBCRG;EDSH,gBAAA;AAFJ;;AAKA;EACI,mBAAA;EACA,cAAA;EACA,eCtBK;ADoBT;;AAKA;EACI,yBAAA;AAFJ;;AAKA;EACI,wBAAA;EACA,yBAAA;AAFJ","sourcesContent":["@use \"styles/colors\";\n@use \"styles/typography\";\n\n.container {\n    display: flex;\n    flex-direction: column;\n    margin-top: 18px;\n}\n\n.map-container {\n    height: 350px;\n}\n\n.map-info {\n    font-size: typography.$header-s;\n    font-weight: typography.$bold;\n    margin: 20px 0px;\n}\n\n.error-text {\n    margin-bottom: 10px;\n    color: colors.$error;\n    font-size: typography.$body-s;\n}\n\n.error-border {\n    border: solid 2px colors.$error;\n}\n\n.error-border:focus-within {\n    outline: none !important;\n    border: solid 2px colors.$error;\n}","$body-s: 12px;\n$body-m: 14px;\n$body-l: 16px;\n$header-xs: 18px;\n$header-s: 20px;\n$header-m: 24px;\n$header-l: 34px;\n$bold: bold;\n$semi-bold: 600;\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `MapField_container__femHr`,
	"map-container": `MapField_map-container__aZHyR`,
	"map-info": `MapField_map-info__PiJ10`,
	"error-text": `MapField_error-text__aW0f1`,
	"error-border": `MapField_error-border__r6Tyl`
};
export default ___CSS_LOADER_EXPORT___;
